import React, { Component } from "react";
import { NavItem, Nav, NavDropdown } from "react-bootstrap";
import SearchBar from "../SearchBar/SearchBar";
import { ApolloClient } from "apollo-client";
import { Query } from "react-apollo";
import { InMemoryCache } from "apollo-cache-inmemory";
import gql from "graphql-tag";
import HttpLinkServices from "../../services/HttpLinkServices";
import { RedirectURL } from "../../variables/RedirectURL";
import ErrorModal from "../Modal/ErrorModal";

const account_client = new ApolloClient({
  link: HttpLinkServices.account,
  cache: new InMemoryCache()
});

const urlToPath = RedirectURL(window.location.host);

class HeaderLinks extends Component {
  constructor() {
    super();
    this.state = {
      width: document.querySelector("body").offsetWidth
    };
  }
  updateDimensions() {
    this.setState({ width: document.querySelector("body").offsetWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    return (
      <div>
        <Nav pullRight>
          <Query
            client={account_client}
            query={gql`
              {
                get_authenticated_user {
                  id
                  first_name
                  token
                  profile {
                    is_admin
                  }
                }
              }
            `}
          >
            {({ loading, error, data }) => {
              if (loading) return <div>Carregando...</div>;
              if (error) return <ErrorModal />;

              return (
                <NavDropdown
                  title={"Olá, " + data.get_authenticated_user.first_name}
                  id="basic-nav-dropdown-right"
                >
                  {data.get_authenticated_user.profile &&
                    data.get_authenticated_user.profile.is_admin && (
                      <NavItem
                        target="_blank"
                        data-gtm-type="click"
                        data-gtm-clicktype="menu"
                        data-gtm-name="Admin"
                        key={1}
                        className="nav-link"
                        activeClassName="active"
                        href={`${urlToPath}/api/v1/account/authtoken?token=${data.get_authenticated_user.token}`}
                      >
                        Admin
                      </NavItem>
                    )}
                  <Query
                    client={account_client}
                    query={gql`
                      {
                        account_auth {
                          logout_url
                        }
                      }
                    `}
                  >
                    {({ loading, error, data }) => {
                      if (loading) return <div></div>;
                      if (error) return <ErrorModal />;

                      if (!data.account_auth.logout_url) {
                        return <div></div>;
                      }

                      return (
                        <NavItem
                          data-gtm-type="click"
                          data-gtm-clicktype="menu"
                          data-gtm-name="Sair"
                          key={2}
                          className="nav-link"
                          activeClassName="active"
                          href={data.account_auth.logout_url}
                          onClick={()=> document.cookie = 'gtmEvent=; expires = Thu, 01 jan 1970 00:00:00 GMT'}
                        >
                          Sair
                        </NavItem>
                      );
                    }}
                  </Query>
                </NavDropdown>
              );
            }}
          </Query>
        </Nav>
        {this.state.width > 991 && <SearchBar />}
      </div>
    );
  }
}

export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx